/*
 * Wedding info capture (app-free).
 * - Collects チャペル名 / お打ち合わせブライダルサロン名 / 担当プランナー / 挙式日 / 備考
 * - Persists to cart attributes (via /cart/update) so it lands on the order's
 *   "Additional details", and mirrors to localStorage as a cross-session cache.
 * - Shows a modal after login when required fields are missing, provides an
 *   always-visible form on the cart page, and blocks checkout until required
 *   fields are filled. Accelerated checkout buttons are hidden via CSS so the
 *   cart form cannot be bypassed.
 */
(function () {
  'use strict';

  var cfg = window.WeddingInfoConfig;
  if (!cfg) return;

  var KEYS = cfg.keys; // { chapel, salon, planner, date, remarks } -> attribute name
  var REQUIRED = cfg.required; // array of attribute names
  var LS_KEY = 'weddingInfo:v1';
  // Minimum days that must remain before the wedding to allow ordering.
  // Read from the shop metafield custom.order_cutoff_days; 0 = disabled.
  var CUTOFF = parseInt(cfg.orderCutoffDays, 10) || 0;
  // QA aid: ?wi_cutoff=N may only make the rule STRICTER (never bypass it).
  var cutoffOverride = window.location.search.match(/[?&]wi_cutoff=(\d+)/);
  if (cutoffOverride) CUTOFF = Math.max(CUTOFF, parseInt(cutoffOverride[1], 10) || 0);

  // ---- source of truth: cart attributes (priority) merged with localStorage ----
  function readLS() {
    try {
      return JSON.parse(localStorage.getItem(LS_KEY)) || {};
    } catch (e) {
      return {};
    }
  }
  function writeLS() {
    try {
      localStorage.setItem(LS_KEY, JSON.stringify(state));
    } catch (e) {
      /* storage disabled */
    }
  }

  var lsState = readLS();
  var state = {};
  Object.keys(cfg.cart).forEach(function (attr) {
    var fromCart = cfg.cart[attr];
    state[attr] = fromCart && fromCart.length ? fromCart : lsState[attr] || '';
  });

  function isComplete() {
    return REQUIRED.every(function (attr) {
      return state[attr] && String(state[attr]).trim() !== '';
    });
  }

  // ---- order cutoff (block when the wedding is fewer than N days away) ----
  function daysUntilWedding() {
    var v = state[KEYS.date];
    if (!v) return null;
    var parts = String(v).split('-');
    if (parts.length !== 3) return null;
    var y = +parts[0], m = +parts[1], d = +parts[2];
    if (!y || !m || !d) return null;
    var now = new Date();
    var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    var wedding = new Date(y, m - 1, d);
    return Math.round((wedding - today) / 86400000);
  }
  function isWithinCutoff() {
    if (CUTOFF <= 0) return false; // feature disabled / metafield not set
    var d = daysUntilWedding();
    if (d === null) return false; // no date yet -> handled by required-field check
    return d < CUTOFF;
  }
  // ---- solo shipping restriction (個別配送不可 tag alone in cart) ----
  // Flag is server-rendered by cart-solo-restriction.liquid and re-renders with
  // the cart, so reading it fresh at click time is always current.
  function isSoloRestricted() {
    var el = document.querySelector('[data-wi-solo]');
    return !!el && el.getAttribute('data-wi-solo') === 'true';
  }

  function canCheckout() {
    return isComplete() && !isWithinCutoff() && !isSoloRestricted();
  }

  // ---- chapel filtering by localStorage.chapel_type (brand) ----
  // The customer's brand is stored client-side in localStorage['chapel_type']
  // (set by a separate feature). Empty/unset -> show all chapels.
  function getChapelType() {
    try {
      return localStorage.getItem('chapel_type') || '';
    } catch (e) {
      return '';
    }
  }
  function filterChapelSelect(sel) {
    if (!sel || sel.tagName !== 'SELECT') return;
    var type = getChapelType();
    var opts = sel.querySelectorAll('option[data-chapel-type]');
    for (var i = 0; i < opts.length; i++) {
      var match = !type || opts[i].getAttribute('data-chapel-type') === type;
      opts[i].hidden = !match;
      opts[i].disabled = !match;
    }
    // If the selected chapel no longer belongs to the active brand, clear it.
    var current = sel.selectedOptions && sel.selectedOptions[0];
    if (current && current.value && current.hidden) {
      sel.value = '';
      state[KEYS.chapel] = '';
      persist();
      syncCheckoutButtons();
    }
  }
  function filterChapelOptions() {
    document.querySelectorAll('select[data-wi-key="chapel"]').forEach(filterChapelSelect);
  }
  // Re-apply the filter after the cart section re-renders (morph resets options).
  function observeCartRerenders() {
    var target = document.getElementById('MainContent');
    if (!target || target.__wiChapelObserved) return;
    target.__wiChapelObserved = true;
    var timer = null;
    new MutationObserver(function () {
      if (timer) clearTimeout(timer);
      timer = setTimeout(filterChapelOptions, 100);
    }).observe(target, { childList: true, subtree: true });
  }
  function updateCutoffUI() {
    // Only the banner communicates the cutoff. We intentionally do NOT flag the
    // date field as an error here, since it would surface the "enter the date"
    // message even though the date is filled (just too soon).
    var msg = document.querySelector('[data-wi-cutoff]');
    if (msg) msg.hidden = !isWithinCutoff();
  }

  // ---- persistence ----
  var saveTimer = null;
  function persist() {
    writeLS();
    if (saveTimer) clearTimeout(saveTimer);
    saveTimer = setTimeout(function () {
      var attributes = {};
      Object.keys(state).forEach(function (attr) {
        attributes[attr] = state[attr] || '';
      });
      fetch(cfg.updateUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: attributes })
      }).catch(function () {
        /* keep localStorage copy; will retry on next change */
      });
    }, 250);
  }

  // If the cart has no attributes yet but localStorage seeded values, push them.
  function seedCartIfNeeded() {
    var cartEmpty = Object.keys(cfg.cart).every(function (attr) {
      return !cfg.cart[attr];
    });
    var haveValues = Object.keys(state).some(function (attr) {
      return state[attr];
    });
    if (cartEmpty && haveValues) persist();
  }

  // ---- input helpers (work over any container holding [data-wi-key] fields) ----
  function fillInputs(container) {
    container.querySelectorAll('[data-wi-key]').forEach(function (input) {
      var attr = KEYS[input.getAttribute('data-wi-key')];
      if (attr && state[attr] != null) input.value = state[attr];
    });
  }

  function fieldWrapper(input) {
    return input.closest('.wi-field');
  }
  function setError(input, on) {
    var wrap = fieldWrapper(input);
    if (wrap) wrap.classList.toggle('wi-field--error', !!on);
  }

  function validate(container) {
    var ok = true;
    container.querySelectorAll('[data-wi-key][required]').forEach(function (input) {
      var empty = input.value.trim() === '';
      setError(input, empty);
      if (empty && ok) input.focus();
      if (empty) ok = false;
    });
    return ok;
  }

  function syncCheckoutButtons() {
    var ok = canCheckout();
    document.querySelectorAll('[name="checkout"], #checkout').forEach(function (btn) {
      btn.classList.toggle('wi-checkout-blocked', !ok);
    });
    updateCutoffUI();
  }

  // ---- modal ----
  function openModal(modal) {
    modal.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    var first = modal.querySelector('[data-wi-key]');
    if (first) setTimeout(function () { first.focus(); }, 30);
  }
  function closeModal(modal) {
    modal.hidden = true;
    document.documentElement.style.overflow = '';
  }

  function initModal() {
    var modal = document.getElementById('wedding-info-modal');
    if (!modal) return;
    var form = modal.querySelector('[data-wi-form]');
    if (!form) return;

    fillInputs(modal);
    filterChapelOptions();

    // Auto-open after login when incomplete, except on the cart page where the
    // inline form is already visible.
    // `?wedding_info_preview=1` force-opens the modal for QA (e.g. local dev,
    // where customer login is unavailable on the 127.0.0.1 preview URL).
    var onCart = isCartPage();
    var forcePreview = /[?&]wedding_info_preview=1(&|$)/.test(window.location.search);
    if (forcePreview || (cfg.loggedIn && !isComplete() && !onCart)) openModal(modal);

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!validate(form)) return;
      form.querySelectorAll('[data-wi-key]').forEach(function (input) {
        state[KEYS[input.getAttribute('data-wi-key')]] = input.value.trim();
      });
      persist();
      syncCheckoutButtons();
      closeModal(modal);
      var cart = document.querySelector('[data-wi-cart]');
      if (cart) fillInputs(cart);
    });

    modal.querySelectorAll('[data-wi-close]').forEach(function (btn) {
      btn.addEventListener('click', function () { closeModal(modal); });
    });
  }

  // ---- cart page inline fields ----
  function isCartPage() {
    return /\/cart(\/|$|\?)/.test(window.location.pathname + window.location.search);
  }

  function initCartFields() {
    var container = document.querySelector('[data-wi-cart]');
    if (!container) return;
    fillInputs(container);
    seedCartIfNeeded();
    filterChapelOptions();
    observeCartRerenders();
    syncCheckoutButtons();
  }

  // Live-persist edits made in the cart inline form (delegated so it survives
  // the cart component re-rendering itself on quantity changes).
  function handleFieldEvent(e) {
    var input = e.target.closest ? e.target.closest('[data-wi-key]') : null;
    if (!input) return;
    if (!input.closest('[data-wi-cart]')) return; // modal persists on submit only
    state[KEYS[input.getAttribute('data-wi-key')]] = input.value.trim();
    persist();
    setError(input, false);
    syncCheckoutButtons();
  }
  document.addEventListener('input', handleFieldEvent);
  document.addEventListener('change', handleFieldEvent);

  // ---- checkout gating (covers cart page button and cart drawer button) ----
  function blockOnCart() {
    var container = document.querySelector('[data-wi-cart]');
    if (container) {
      container.scrollIntoView({ behavior: 'smooth', block: 'center' });
      if (!isComplete()) validate(container);
      updateCutoffUI();
    } else {
      var modal = document.getElementById('wedding-info-modal');
      if (modal && cfg.loggedIn) openModal(modal);
    }
  }

  function guardCheckout(e) {
    if (canCheckout()) return;
    var target = e.target;
    var btn = target.closest
      ? target.closest('[name="checkout"], #checkout')
      : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    if (!isCartPage()) {
      window.location.href = window.Theme && Theme.routes ? Theme.routes.cart_url || '/cart' : '/cart';
      return;
    }
    blockOnCart();
  }
  document.addEventListener('click', guardCheckout, true);
  document.addEventListener(
    'submit',
    function (e) {
      var f = e.target;
      if (f && f.id === 'cart-form' && !canCheckout()) {
        e.preventDefault();
        e.stopPropagation();
        blockOnCart();
      }
    },
    true
  );

  // ---- boot ----
  function boot() {
    initModal();
    initCartFields();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
